import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useDndMonitor } from '@dnd-kit/core';
import { css } from '@emotion/react';
import { useCallback } from 'react';
import { isMobile } from 'react-device-detect';
import { shallowEqual, useDispatch } from 'react-redux';
import { useSocketSend } from '../../../../context/webSocket/webSocketContext';
import { setDraggingBombIsOverTarget, setDraggingBombType, thunkBombSeat } from '../../../../redux/actions/bombsActions';
import { useAppSelector } from '../../../../redux/store';
import { isBombType } from '../../../../types/bombTypes';
import { isSeatIndex } from '../../../../types/pokerTypes';
import { DraggableBombButtons } from './draggableBombButtons';
const MOBILE_DRAG_AREA_MIN_PX = 20;
const MOBILE_CONTAINER_CSS = css `
  display: flex;
  flex-direction: row;
`;
const MOBILE_DRAG_AREA_CSS = css `
  width: ${MOBILE_DRAG_AREA_MIN_PX}px;
  min-width: ${MOBILE_DRAG_AREA_MIN_PX}px;
  height: ${MOBILE_DRAG_AREA_MIN_PX}px;
  min-height: ${MOBILE_DRAG_AREA_MIN_PX}px;
`;
export const BombsPanelContents = () => {
    const dispatch = useDispatch();
    const numBombsToThrow = useAppSelector((state) => state.session.numBombsToThrow);
    const socketSend = useSocketSend();
    const draggingBomb = useAppSelector((state) => state.bombs.draggingBomb, shallowEqual);
    const onDragStart = useCallback((event) => {
        const bombType = event.active.id;
        if (typeof bombType !== 'number' && isBombType(bombType)) {
            dispatch(setDraggingBombType(bombType));
        }
    }, [dispatch]);
    const onDragOver = useCallback((event) => {
        if (!draggingBomb) {
            return;
        }
        const newIsOverTarget = !!(event.collisions || []).length;
        if (newIsOverTarget !== !!draggingBomb.isOverTarget) {
            dispatch(setDraggingBombIsOverTarget(newIsOverTarget));
        }
    }, [dispatch, draggingBomb]);
    const onDragEndOrCancel = useCallback((event) => {
        dispatch(setDraggingBombIsOverTarget(false));
        if (!draggingBomb) {
            return;
        }
        const seatIndex = event.over?.id;
        if (typeof seatIndex !== 'string' && isSeatIndex(seatIndex)) {
            dispatch(thunkBombSeat(seatIndex, draggingBomb.type, numBombsToThrow, socketSend, 'bombs panel'));
        }
        setDraggingBombType(undefined);
    }, [dispatch, draggingBomb, numBombsToThrow, socketSend]);
    useDndMonitor({
        onDragStart,
        onDragOver,
        onDragCancel: onDragEndOrCancel,
        onDragEnd: onDragEndOrCancel
    });
    const bombsContents = _jsx(DraggableBombButtons, {});
    if (isMobile) {
        /**
         * On mobile, you can't drag on a bomb button to scroll the bombs container, because that would interfere with the dragging-to-player
         * behavior. Therefore, it might be difficult to find a spot to drag just the container if the space is full of bomb buttons.
         * In this case, we can add a little space to the right side of the scrollable bombs container to guarantee there is always some
         * empty space to drag the container with your finger and not trigger other interactions.
         */
        return (_jsxs("div", { css: MOBILE_CONTAINER_CSS, children: [_jsx("div", { children: bombsContents }), _jsx("div", { css: MOBILE_DRAG_AREA_CSS })] }));
    }
    return bombsContents;
};
